import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, UploadFile, message } from "antd";
import { useNavigate } from "react-router-dom";
import SettingMyProfileForm from "./SettingMyProfileForm";
import { useAppSelector } from "store";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useUserUpdateProfile } from "hooks/useAuth";
import { getAuthProfile } from "services/authAPI";
import { setProfileAndContact } from "store/slices/authSlice";
import { useAppDispatch } from "store";

const SettingMyProfile = () => {
  const [avatar, setAvatar] = useState<UploadFile[] | undefined>([]);

  const navigate = useNavigate();
  const { profile } = useAppSelector((state) => state.auth);

  const { mutate, isPending } = useUserUpdateProfile();

  const [form] = Form.useForm();

  const dispatch = useAppDispatch();

  const onFinish = (values: any) => {
    mutate({
      id: profile?.user?.id || "",
      first_name: values.first_name,
      last_name: values.last_name,
      mobile: values.mobile,
      email: values.email,
      gender: values.gender,
      image: values.image[0]?.url,
      birth_date: values.birth_date ? dayjs(values.birth_date).format("YYYY-MM-DD") : undefined,
    }, {
      onSuccess: () => {
        message.success("แก้ไขโปไฟล์สำเร็จ");
        getAuthProfile()
        .then((res) => {
          if (res.status === "success") {
            dispatch(
              setProfileAndContact({
                profile: res.profile,
                contact: res.contact,
              })
            );
            }
        })
      },
      onError: () => {
          message.error("แก้ไขโปไฟล์ไม่สำเร็จ");
      },
    });
  };

 

  useEffect(() => {

    if (profile?.user?.image_url) {
      setAvatar([{ 
        uid: "uuid",
        name: "avatar",
        url: profile?.user?.image_url,
      }]);
    } else {
      setAvatar(undefined);
    }
    form.setFieldsValue({
      first_name: profile?.user?.first_name,
      last_name: profile?.user?.last_name,
      mobile: profile?.user?.mobile,
      email: profile?.user?.email,
      gender: profile?.user?.gender,
      birth_date: profile?.user?.birth_date ? dayjs(profile?.user?.birth_date) : undefined,
      card_id: profile?.user?.card_id,
      image: [
        {
          uid: "",
          name: "รูปโปรไฟล์",
          status: "done",
          id: "",
          url: profile?.user?.image_url,
        },
      ],
    });
  }, []);

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>โปรไฟลของฉัน</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <SettingMyProfileForm
                form={form}
                onFinish={onFinish}
                avatar={avatar}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingMyProfile;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
